exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "/*\n* Fix to make the table horizontally stretchable\n*/\n.sticky-table .sticky-table-table {\n  /* min-width: 100%; */\n  height: 1px;\n}\n\n.sticky-table .sticky-table-cell {\n  height: 100%;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/Table/StickyTable-FIX.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./src/components/Table/StickyTable-FIX.css
// module chunks = 0